import React, { useEffect } from 'react'
import DashboardLayout from '../../components/dashboardLayout'
import PreExistingTemplatesList from './components/preExistingTemplateList'
import { useParams } from 'react-router-dom'
import PreExistingTemplatesDetails from './components/preExistingTemplateDetails'
import { useCommonApi } from '../../store/api/hooks/commonApiHook'
import toast from 'react-hot-toast'
import { ErrorResponse } from '../../store/api/apiTypes'
import { BusinessFunctionDataType } from '../../_config/types'
import { useFpLoader } from '../../store/api/hooks/fpLoaderHook'
import { trackEvent } from '../../_common/functions'

export type PreExistingTemplateProps = {
    // add props here if needed
}

const PreExistingTemplates: React.FC<PreExistingTemplateProps> = () => {
    const params: any = useParams()
    const conmmonApi: any = useCommonApi()
    const [templates, setTemplates] = React.useState<any[]>([])
    const { showLoader, hideLoader } = useFpLoader()

    const getBusinessFunctions = () => {
        showLoader()
        setTemplates([]) // Clear templates before fetching new data
        conmmonApi.businessFunction(
            { sort_by: 'title', payload: 'business_functions', page: 1, per_page: 1000, alldata: true, has_templates_only: true },
            (data: any) => {
                hideLoader()
                const result = data.data.result?.map((business: any) => {
                    business.id = business.business_function_literal
                    business.name = business.title
                    business.description = business.template_count + ' Examples'
                    business.iconUrl = business?.meta_data?.image || null
                    return business
                })
                trackEvent('template_domains_loaded', { domain_count: result?.length ?? 0 })
                setTemplates(result)
            },
            (error: ErrorResponse<BusinessFunctionDataType>) => {
                hideLoader()
                trackEvent('template_domains_load_failed', { error_message: error.message })
                toast.error(error.message)
            },
        )
    }

    useEffect(() => {
        trackEvent('template_list_page_viewed', {})
        getBusinessFunctions()
    }, [])

    return <DashboardLayout active="my-experiment">{params?.templateid ? <PreExistingTemplatesDetails templates={templates} /> : <PreExistingTemplatesList templates={templates} />}</DashboardLayout>
}

export default PreExistingTemplates
